import React, { useState } from 'react';
import { Runbook, Category } from '../types';

interface CatalogViewProps {
  catalog: Runbook[];
  unlockedSlugs: string[];
  onOpenDetail: (slug: string) => void;
}

export const CatalogView: React.FC<CatalogViewProps> = ({
  catalog,
  unlockedSlugs,
  onOpenDetail,
}) => {
  const [filter, setFilter] = useState<Category>('all');

  const filtered = catalog.filter((rb) => {
    if (filter === 'all') return true;
    return rb.category === filter;
  });

  return (
    <div className="space-y-8">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 border-b border-[#232736] pb-6">
        <div>
          <p className="text-xs uppercase font-mono tracking-widest text-sky-400">
            CATALOG // VERIFIED RUNBOOKS
          </p>
          <h1 className="font-tech text-3xl sm:text-4xl font-bold text-white mt-1">
            Operational Blueprints
          </h1>
          <p className="text-xs text-[#8b92a5] font-mono mt-1">
            Single-problem execution manuals. Instant unlock. Raw Markdown + Styled PDF.
          </p>
        </div>

        <div className="flex flex-wrap gap-1.5">
          {(['all', 'pricing', 'operations', 'sales', 'launch'] as Category[]).map((cat) => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              className={`px-3 py-1 text-xs font-mono rounded border transition ${
                filter === cat
                  ? 'bg-sky-500/20 text-sky-300 border-sky-500/40'
                  : 'bg-[#10121a] text-[#8b92a5] border-[#232736] hover:text-white'
              }`}
            >
              {cat.toUpperCase()}
            </button>
          ))}
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map((rb) => {
          const isUnlocked = unlockedSlugs.includes(rb.slug);
          return (
            <div
              key={rb.id}
              onClick={() => onOpenDetail(rb.slug)}
              className="blueprint-card rounded-xl p-5 border border-[#232736] hover:border-sky-500/50 transition cursor-pointer flex flex-col justify-between group"
            >
              <div className="space-y-4">
                <div className="flex items-center justify-between text-xs font-mono text-[#8b92a5]">
                  <span className="text-sky-400 font-bold">{rb.code}</span>
                  <span className="text-white font-bold font-mono">${rb.price}</span>
                </div>
                <div>
                  <h3 className="font-tech text-xl font-bold text-white leading-snug group-hover:text-sky-300 transition">
                    {rb.title}
                  </h3>
                  <p className="text-xs font-mono text-[#8b92a5] mt-1.5 italic line-clamp-2">
                    {rb.subtitle}
                  </p>
                </div>
              </div>

              <div className="pt-6 border-t border-[#232736] mt-4 flex items-center justify-between text-xs font-mono">
                <span className="text-[10px] uppercase text-[#525970]">{rb.category}</span>
                <span
                  className={
                    isUnlocked
                      ? 'text-emerald-400 font-bold'
                      : 'text-zinc-400 group-hover:text-white'
                  }
                >
                  {isUnlocked ? 'UNLOCKED ✓' : 'INSPECT →'}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
